exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".profile-settings-1{fill:#1e4e69}.profile-settings-2{fill:none}.profile-settings-3{fill:#bfe7e3}\n", ""]);
